import { _ } from 'core-js'
import core from '../../../js/core/core'
import * as types from '../mutation-types'
import EventBus from '@/vue/events/event-bus'

// initial state
const state = {
    arr_eventList : [],
    selectedSort:2,
    sortedEvents: null,
    arr_liveLeague: [],
    arr_liveEventList: [],
    arr_parlayTdyEventList: [],
    arr_parlayEarlyEventList: [],
    arr_specialEventLeague: [],
    selectedState: null,
    stateList: [],
    favouriteEvents: {},
    favouriteLgeEvents: {},
    selectedBettype: null,
    sortedFavRbEventList: [],
    sortedMatchEventList: [],
    showFavEvents: false,
    favrbeventList: [],
    favotreventList: [],
    sortedFavOtrEventList: [],
    arr_todayRBEventList: [],
    sortedTodayRBEvents: null,
    hideLegHeader: [],
    lableHeader: [],
    arr_otrEventList: [],
    virtualDataList: [],
    showLegCapt: [],
    legCaptDataList: [],
    otrHideLegList: {},
    otrHideTitleList: [],
    otrHideFavLegList: {},
    otrHideFavTitleList: [],
    filter_leagueList: [],
    hotMatchList: [],
    schedule: 1, // 1: all(live,today,result), 2: live, 3: result, 4: today,
    playtype: 1, // 1: normal, 2: selected league, 3: selected country/area
    favouriteTeams: {},
}

// getters
const getters = {
    arr_eventList: state => state.arr_eventList,
    selectedSort: state => state.selectedSort,
    sortedEvents: state => state.sortedEvents,
    arr_liveLeague: state => state.arr_liveLeague,
    arr_liveEventList: state => state.arr_liveEventList,
    arr_parlayTdyEventList: state => state.arr_parlayTdyEventList,
    arr_parlayEarlyEventList: state => state.arr_parlayEarlyEventList,
    arr_specialEventLeague: state => state.arr_specialEventLeague,
    selectedState: state => state.selectedState,
    stateList: state => state.stateList,
    favouriteEvents: state => state.favouriteEvents,
    favouriteLgeEvents: state => state.favouriteLgeEvents,
    selectedBettype: state => state.selectedBettype,
    sortedFavRbEventList: state => state.sortedFavRbEventList,
    sortedMatchEventList: state => state.sortedMatchEventList,
    showFavEvents: state => state.showFavEvents,
    favrbeventList: state => state.favrbeventList,
    favotreventList: state => state.favotreventList,
    sortedFavOtrEventList: state => state.sortedFavOtrEventList,
    arr_todayRBEventList: state => state.arr_todayRBEventList,
    sortedTodayRBEvents: state => state.sortedTodayRBEvents,
    hideLegHeader: state => state.hideLegHeader,
    lableHeader: state => state.lableHeader,
    arr_otrEventList: state => state.arr_otrEventList,
    virtualDataList: state =>  state.virtualDataList,
    showLegCapt: state => state.showLegCapt,
    legCaptDataList: state => state.legCaptDataList,
    otrHideLegList: state => state.otrHideLegList,
    otrHideTitleList: state => state.otrHideTitleList,
    otrHideFavLegList: state => state.otrHideFavLegList,
    otrHideFavTitleList: state => state.otrHideFavTitleList,
    filter_leagueList: state=>state.filter_leagueList,
    schedule: state=>state.schedule,
    playtype: state=>state.playtype,
    favouriteTeams: state=>state.favouriteTeams,
    hotMatchList: state=>state.hotMatchList,
}

// actions
const actions = {
    getSportOdds(context, payload){  
      var bool_loading = false;           
      if(payload && payload.loading == '1'){
        // this.commit('REFRESHSCREEN', true)
        bool_loading = true
      }
      var httpMethod = 'get'

      var data = {
        sprtid: this.getters.selectedSport,
        schedule: this.getters.schedule,
        lang: window._langid,
        // spread: this.getters.account.spread,          
        // odd: (this.getters.arr_selectedTemplate.subTemplateId == '2' && this.getters.account.oddsType!='am') ? this.getters.oddTypesList.EU.key: this.getters.account.oddsType,
        // page: 0, // this.getters.selectedPage,
        // sorttyp: 1,             
        // date: date,
        sdate: this.getters.selected_date,
        timezone: this.getters.selected_timezone,
        plytypgrp : this.getters.playtype,
        enableLoading: bool_loading,
        token: payload.token,
      }

      if(data.plytypgrp == 2 && this.getters.selected_league) {
        data.league = this.getters.selected_league
      }
      if(data.plytypgrp == 3 && this.getters.selected_country) {
        data.country = this.getters.selected_country
      }

      var url = window._baseUrl + '/sport-odds-preview'
      // //cdn checking
      // if(url == window._baseUrl + '/sport-odds' || url == window._baseUrl + '/sport-odds-preview') {
      //   url += '/' + this.getters.schedule
      //   httpMethod = 'get'
      // }
      
      core.$ajax({
        method: httpMethod,
        url: url,
        data: data
      }).done(((res)=> {
        
        var events = _.cloneDeep(res.events)
        
        if(!this.getters.s_odd && this.getters.arr_selectedLeague && this.getters.arr_selectedLeague.leagueid && res.events && res.events.length>0){
          var c = this.getters.arr_selectedLeague.c
          this.dispatch('selectLeague',{
            leagueid : res.events[0][0].lgeid,
            lgecapt: res.events[0][0].lgecapt,
            c: c
          })
        }
        this.commit('TODAYRBEVENTLIST',[])
        this.commit('EVENTLIST',events)
        if(this.getters.arr_selectedTemplate.subTemplateId=='4'){
          this.commit('CSODDSEVENT',events)
        }
        this.commit('TOTALPAGE', res.ttlPg)
        if(this.getters.selectedPage > res.ttlPg) {
          this.commit('SELECTED_PAGE', res.ttlPg)
        }
        if(res.earlyParlayDateList){
          this.commit('PARLAYDATELIST',earlyParlayDateList)
        }
        this.commit('LOADINGSCREEN', false)

        this.dispatch('sortEvents')
      }).bind(this)).catch((errRes)=> {
        console.log(errRes)
      })
      
      if(this.getters.playtype == 1) {
        this.dispatch('getHotMatch', {
          data: data,
        })
      }
    },
    getHotMatch(context, payload){
      
      var httpMethod = 'get'
      var url = window._baseUrl + '/hot-matches-preview'
      //cdn checking
      // if(url == window._baseUrl + '/hot-matches' || url == window._baseUrl + '/hot-matches-preview') {
      //   url += '/' + this.getters.schedule
      //   httpMethod = 'get'
      // }

      payload['data']['action'] = 'gethotMatch';
      core.$ajax({
        method: httpMethod,
        url: url,
        data: payload['data']
      }).done(((res)=> {
        this.commit('HOT_MATCH_LIST', res)
      }))
    },
    // getSportOdds(context, payload){  
    //   var bool_loading = true;           
    //   if(payload && payload.loading == '1'){
    //       bool_loading = false
    //   }

    //   var bettype =this.getters.arr_selectedTemplate.sportId;
    //   var plytype = this.getters.arr_selectedTemplate.plytype;
    //   var schedule = this.getters.int_marketToggle;
    //   var date = '0';
    //   var httpMethod = 'post'

    //   if(payload && payload.isResult){
    //     schedule = 5
    //   }

    //   if(payload && payload.livetv){ //livetv date change
    //       bettype = (payload.sportId)?payload.sportId:"";
    //       plytype = (payload.playType)?payload.playType:"";
    //       schedule = (payload.schedule)?payload.schedule:"";
    //       date = payload.sDate;
    //   }else{
    //     if(this.getters.int_selectedParlayDate && schedule == '2'){  
    //       date = this.getters.int_selectedParlayDate    
    //     }
    //   }
      
    //   if(this.getters.arr_selectedTemplate.subTemplateId == '2'){
    //     date = this.getters.int_selectedParlayDate    
    //     plytype = '5'
    //   }

    //   // if(this.getters.gameBannerId && this.getters.editionStand == '3') {
    //   //   bettype = 'G3'
    //   // }

    //   var data = {
    //     sprtid: bettype,
    //     schedule: schedule,
    //     lang: window._langid,
    //     spread: this.getters.account.spread,          
    //     odd: (this.getters.arr_selectedTemplate.subTemplateId == '2' && this.getters.account.oddsType!='am') ? this.getters.oddTypesList.EU.key: this.getters.account.oddsType,
    //     page: 0, // this.getters.selectedPage,
    //     sorttyp: 1,             
    //     date: date,
    //     sdate: this.getters.selected_date,
    //     timezone: this.getters.selected_timezone,
    //     plytypgrp : plytype,
    //     enableLoading: bool_loading,
    //     token: payload.token,
    //   }

    //   if(!this.getters.showFavEvents){
    //     let lgList = []
    //     if(this.getters.arr_selectedTemplate.int_marketToggle=='1'){
    //       if(this.getters.todayRBLeagueList && Object.keys(this.getters.todayRBLeagueList).length > 0){
    //         _.forEach(this.getters.todayRBLeagueList, function(d, k){
    //           lgList.push(d.id)
    //         })
    //       }
    //     }
    //     if(this.getters.arr_leagueList && Object.keys(this.getters.arr_leagueList).length > 0){
    //       _.forEach(this.getters.arr_leagueList, function(d, k){
    //         lgList.push(d.id)
    //       })
    //     }

    //     data.leagues = lgList
    //   }
      
    //   //if show league
    //   if(this.getters.isShowFilter){
    //     if(this.getters.arr_selectedLeagueList){
    //       data.leagues = this.getters.arr_selectedLeagueList
    //     }
    //   }
    //   // if(this.getters.arr_selectedLeague){
    //   //   if(this.getters.arr_selectedLeague.leagueid ) {
    //   //     data.leagues = [this.getters.arr_selectedLeague.leagueid]  
    //   //   }
    //   // }
    //   // if(this.getters.arr_selectedTemplate){ 
    //     // if(this.getters.arr_selectedTemplate.leagueid ) {
    //     //   data.leagues = [this.getters.arr_selectedTemplate.leagueid]  
    //     // }else{
    //     //   if((this.getters.arr_selectedLeague && Object.keys(this.getters.arr_selectedLeague).length == 0) ){
    //     //     if(this.getters.arr_leagues && Object.keys(this.getters.arr_leagues).length > 0){ // select multiple league
    //     //       var lgList = []
    //     //       _.forEach(this.getters.arr_leagues, function(d, k){
    //     //         lgList.push(d.leagueid)
    //     //       })
              
    //     //       data.leagues = lgList
    //     //     }else if(this.getters.arr_leagueList && Object.keys(this.getters.arr_leagueList).length > 0){ 
    //     //       var lgList = []
    //     //       var arrLgList = this.getters.arr_leagueList

    //     //       if(payload.state != ''){
                
    //     //         arrLgList = _.filter(this.getters.arr_leagueList, function(o){
    //     //           if(o.state == payload.state){
    //     //             return true
    //     //           }
    //     //         })
    //     //       }

    //     //       _.forEach(arrLgList, function(d, k){
    //     //         lgList.push(d.id)
    //     //       })
              
    //     //       data.leagues = lgList
    //     //     }
    //     //   }else if(this.getters.arr_selectedLeagues && Object.keys(this.getters.arr_selectedLeagues).length > 0){
    //     //     var lgList = []
    //     //     _.forEach(this.getters.arr_selectedLeagues, function(d, k){
    //     //       lgList.push(d.leagueid)
    //     //     })

    //     //     data.leagues = lgList
    //     //   }else{
    //     //     if(this.getters.arr_selectedLeague && Object.keys(this.getters.arr_selectedLeague).length > 0){ // selected single league
    //     //       data.leagues = [this.getters.arr_selectedLeague.leagueid]  
    //     //     }
    //     //   }
    //     // }
    //   // }
      
    //   if(this.getters.selectedSort){
    //     data.sorttyp = this.getters.selectedSort
    //   }

    //   var url = ''
    //   if(this.getters.cookieLeague) {
    //     var cookieLeague =  this.getters.cookieLeague
    //     if( Object.keys(cookieLeague).length > 0){
    //       url = window._baseUrl + '/sport-odds-leagues'
    //       var selectedMarket = this.getters.selectedMarket
    //       var selectedSport = this.getters.arr_selectedTemplate.sportId
  
    //       if(this.getters.isGameBannerSelected) {
    //         selectedBettype += 'gmBanner'
    //       }
    //       if(!this.getters.selectAllLeague){
    //         if(cookieLeague[selectedMarket]){
    //           if(cookieLeague[selectedMarket][selectedSport] && cookieLeague[selectedMarket][selectedSport].length>0){
    //             data.leagues = cookieLeague[selectedMarket][selectedSport]
    //           }else{
    //             if(this.getters.account.previewFlag == true){
    //               url = window._baseUrl + '/sport-odds-leagues-preview';
    //               if(this.getters.s_odd){
    //                 url = window._baseUrl + '/sport-odds-preview';
    //               }
    //             }else{
    //               url = window._baseUrl + '/sport-odds-leagues';
    //               if(this.getters.s_odd){
    //                 url = window._baseUrl + '/sport-odds';
    //               }
    //             }
    //           }
    //         }else{
    //           if(this.getters.account.previewFlag == true){
    //             url = window._baseUrl + '/sport-odds-leagues-preview';
    //             if(this.getters.s_odd){
    //               url = window._baseUrl + '/sport-odds-preview';
    //             }
    //           }else{
    //             url = window._baseUrl + '/sport-odds-leagues';
    //             if(this.getters.s_odd){
    //               url = window._baseUrl + '/sport-odds';
    //             }
    //           }
    //         }
    //       }else{
    //         if(this.getters.account.previewFlag == true){
    //           url = window._baseUrl + '/sport-odds-leagues-preview';
    //           if(this.getters.s_odd){
    //             url = window._baseUrl + '/sport-odds-preview';
    //           }
    //         }else{
    //           url = window._baseUrl + '/sport-odds-leagues';
    //           if(this.getters.s_odd){
    //             url = window._baseUrl + '/sport-odds';
    //           }
    //         }
    //       }
    //     }
    //     if(this.getters.filter_select_all){
    //       if(this.getters.account.previewFlag == true){
    //         url = window._baseUrl + '/sport-odds-preview';
    //       }else{
    //         url = window._baseUrl + '/sport-odds';
    //       }
    //     }
    //   }else{
    //     if(this.getters.account.previewFlag == true){
    //       url = window._baseUrl + '/sport-odds-leagues-preview';
    //       if(this.getters.s_odd){
    //         url = window._baseUrl + '/sport-odds-preview';
    //       }
    //     }else{
    //       url = window._baseUrl + '/sport-odds-leagues';
    //       if(this.getters.s_odd){
    //         url = window._baseUrl + '/sport-odds';
    //       }
    //       if(this.getters.filter_select_all){
    //         if(this.getters.account.previewFlag == true){
    //           url = window._baseUrl + '/sport-odds-preview';
    //         }else{
    //           url = window._baseUrl + '/sport-odds';
    //         }
    //       }
    //     }
    //   }
    //   var schdl = data.schedule;
    //   //cdn checking
    //   if(url == window._baseUrl + '/sport-odds' || url == window._baseUrl + '/sport-odds-preview') {
    //     url += '/' + data.schedule
    //     httpMethod = 'get'
    //     data.gameMenuId = 0;
    //     delete data.leagues
    //     delete data.schedule
    //   }

    //   //if is show fav events
    //   if(payload.showfavorite!=undefined){
    //     this.commit('SPORT_SHOW_FAV_EVENTS', payload.showfavorite)
    //   } else {

    //   }

    //   if(this.getters.showFavEvents) {
    //     // _.unset(data, 'leagues')
    //     // data.events = this.getters.favouriteEvents[this.getters.selectedMarket][this.getters.arr_selectedTemplate.sportId]
    //     if(this.getters.favouriteEvents[this.getters.arr_selectedTemplate.sportId] && Object.keys(this.getters.favouriteEvents[this.getters.arr_selectedTemplate.sportId]).length>0){
    //       data.events = this.getters.favouriteEvents[this.getters.arr_selectedTemplate.sportId]
    //     } else {
    //       data.events = '0' //no event sel
    //     }
    //     if(this.getters.favouriteLgeEvents[this.getters.arr_selectedTemplate.sportId] && Object.keys(this.getters.favouriteLgeEvents[this.getters.arr_selectedTemplate.sportId]).length>0){
    //       data.lgevents = this.getters.favouriteLgeEvents[this.getters.arr_selectedTemplate.sportId]
    //     } else {
    //       data.lgevents = '0' //no event sel
    //     }
       
    //     url = window._baseUrl + '/sport-odds-favevents'
        
    //     httpMethod = 'post'
    //     if(data.token == undefined){
    //       data.token = window.token.arr_7;
    //     }
    //     data.showFav = '1'
    //     data.schedule = schdl;
    //   }
    //   //if is parlay show euro odds
    //   if(plytype == '5' && this.getters.account.oddsType!='am') {
    //     data.odd = this.getters.oddTypesList.EU.key
    //   }

    //   if(payload.sDate!=null){
    //     data.date = payload.sDate;
    //   }else{
    //     data.date = schedule == this.getters.market.earlyMarket.key ? this.getters.int_selectedParlayDate : '0'
    //     if(plytype == '5') {
    //       data.date = this.getters.int_selectedParlayDate
    //     }
    //   }
    //   //default for inplay and today
    //   data.plytypgrp = plytype
    //   if(plytype == '7' ||
    //     plytype == '8' ||
    //     plytype == '9' ||
    //     plytype == '10' ) {
    //         data.plytypgrp = '1'
    //   }

    //   if(data.plytypgrp == '2' && this.getters.int_fullHalfTime == '2') {
    //     data.plytypgrp = '6'
    //   } else if (data.plytypgrp == '3' && this.getters.int_fullHalfTime == '2') {
    //     data.plytypgrp = '7'
    //   }

    //   if(this.getters.editionStand == '0'){
    //     if(this.getters.simDisp == '4'){
    //       data.plytypgrp = '4'
    //     }else if(this.getters.simDisp == '6'){
    //       data.plytypgrp = '12'
    //     }
    //   }

    //   data.gameMenuId = 0;
    //   if(this.getters.isGameBannerSelected) {
    //     data.sprtid = this.getters.gameBannerSportId
    //     data.gameMenuId = this.getters.gameBannerId
    //   }
      
    //   //cdn checking
    //   if(url == window._baseUrl + '/sport-odds' || url == window._baseUrl + '/sport-odds-preview') {
    //     url += '/' + data.schedule
    //     httpMethod = 'get'
    //     delete data.schedule
    //   }
      
    //   core.$ajax({
    //     method: httpMethod,
    //     url: url,
    //     data: data
    //   }).done(((res)=> {
        
    //     var events = _.cloneDeep(res.events)
        
    //     var earlyParlayDateList = res.earlyParlayDateList
        
    //     if(!this.getters.s_odd && this.getters.arr_selectedLeague && this.getters.arr_selectedLeague.leagueid && res.events && res.events.length>0){
    //       var c = this.getters.arr_selectedLeague.c
    //       this.dispatch('selectLeague',{
    //         leagueid : res.events[0][0].lgeid,
    //         lgecapt: res.events[0][0].lgecapt,
    //         c: c
    //       })
    //     }
    //     this.commit('TODAYRBEVENTLIST',[])
    //     this.commit('EVENTLIST',events)
    //     if(this.getters.arr_selectedTemplate.subTemplateId=='4'){
    //       this.commit('CSODDSEVENT',events)
    //     }
    //     this.commit('TOTALPAGE', res.ttlPg)
    //     if(this.getters.selectedPage > res.ttlPg) {
    //       this.commit('SELECTED_PAGE', res.ttlPg)
    //     }
    //     if(res.earlyParlayDateList){
    //       this.commit('PARLAYDATELIST',earlyParlayDateList)
    //     }
    //     this.commit('LOADINGSCREEN', false)

    //     // if(payload&&payload.callback){
    //     //   return payload.callback(res)
    //     // }else{
    //       this.dispatch('sortEvents')
    //     // }
    //   }).bind(this)).catch((errRes)=> {
    //     console.log(errRes)
    //   })

        
    // },
    getTodayRBSportOdds(context, payload){ 
      var bool_loading = true;         
      if(payload && payload.loading == '1'){
          bool_loading = false
      }

      var bettype =this.getters.arr_selectedTemplate.sportId;
      var plytype = this.getters.arr_selectedTemplate.plytype;
      // var schedule = 3;
      var schedule = 4;
      var date = '0';
      var httpMethod = 'post'

      if(payload && payload.livetv){ //livetv date change
          bettype = (payload.sportId)?payload.sportId:"";
          plytype = (payload.playType)?payload.playType:"";
          schedule = (payload.schedule)?payload.schedule:"";
          date = payload.sDate;
      }
     
      if(this.getters.arr_selectedTemplate.subTemplateId == '2'){
        date = this.getters.int_selectedParlayDate    
        plytype = '5'
      }
      
      // if(this.getters.gameBannerId && this.getters.editionStand == '3') {
      //   bettype = 'G3'
      // }

      var gameMenuId=0;
      if(this.getters.arr_selectedTemplate.gameMenuId){
        gameMenuId=this.getters.arr_selectedTemplate.gameMenuId ;
      }
      if(payload.isGameBanner || this.getters.isSpecial) { //special event(eg: EURO 2020)
        //ajaxData.gameMenuId = this.getters.gameBannerId
        gameMenuId = 1
      } else if(this.getters.isGameBannerSelected) {
        gameMenuId = this.getters.gameBannerId
      }

      var data = {
        sprtid: bettype,
        schedule: schedule,
        lang: window._langid,
        spread: this.getters.account.spread,          
        odd: (this.getters.arr_selectedTemplate.subTemplateId == '2' && this.getters.account.oddsType!='am') ? this.getters.oddTypesList.EU.key: this.getters.account.oddsType,
        page: 0, // this.getters.selectedPage,
        sorttyp: this.getters.selectedSort,             
        date: date,
        sdate: this.getters.selected_date,
        timezone: this.getters.selected_timezone,
        plytypgrp : plytype, 
        gameMenuId: gameMenuId,
        enableLoading: bool_loading,
        token: payload.token,
      }

      if(!this.getters.showFavEvents){
        let lgList = []
        if(this.getters.todayRBLeagueList && Object.keys(this.getters.todayRBLeagueList).length > 0){
          _.forEach(this.getters.todayRBLeagueList, function(d, k){
            lgList.push(d.id)
          })
        }

        data.leagues = lgList
      }

      if(this.getters.isShowFilter){
        if(this.getters.arr_selectedLeagueList){
          data.leagues = this.getters.arr_selectedLeagueList
        }
      }
      
      if(this.getters.selectedSort){
        data.sorttyp = this.getters.selectedSort
      }

      var url = ''
      if(this.getters.cookieLeague) {
        var cookieLeague =  this.getters.cookieLeague
        if( Object.keys(cookieLeague).length > 0){
          url = window._baseUrl + '/sport-odds-leagues'
          var selectedMarket = this.getters.selectedMarket
          var selectedSport = this.getters.arr_selectedTemplate.sportId
  
          if(this.getters.isGameBannerSelected) {
            selectedBettype += 'gmBanner'
          }
          if(!this.getters.selectAllLeague){
            if(cookieLeague[selectedMarket]){
              if(cookieLeague[selectedMarket][selectedSport] && cookieLeague[selectedMarket][selectedSport].length>0){
                data.leagues = cookieLeague[selectedMarket][selectedSport]
              }else{
                if(this.getters.account.previewFlag == true){
                  url = window._baseUrl + '/sport-odds-leagues-preview';
                  if(this.getters.s_odd){
                    url = window._baseUrl + '/sport-odds-preview';
                  }
                }else{
                  url = window._baseUrl + '/sport-odds-leagues';
                  if(this.getters.s_odd){
                    url = window._baseUrl + '/sport-odds';
                  }
                }
              }
            }else{
              if(this.getters.account.previewFlag == true){
                url = window._baseUrl + '/sport-odds-leagues-preview';
                if(this.getters.s_odd){
                  url = window._baseUrl + '/sport-odds-preview';
                }
              }else{
                url = window._baseUrl + '/sport-odds-leagues';
                if(this.getters.s_odd){
                  url = window._baseUrl + '/sport-odds';
                }
              }
            }
          }else{
            if(this.getters.account.previewFlag == true){
              url = window._baseUrl + '/sport-odds-leagues-preview';
              if(this.getters.s_odd){
                url = window._baseUrl + '/sport-odds-preview';
              }
            }else{
              url = window._baseUrl + '/sport-odds-leagues';
              if(this.getters.s_odd){
                url = window._baseUrl + '/sport-odds';
              }
            }
          }
        }
        if(this.getters.filter_select_all){
          if(this.getters.account.previewFlag == true){
            url = window._baseUrl + '/sport-odds-preview';
          }else{
            url = window._baseUrl + '/sport-odds';
          }
        }
      }else{
        if(this.getters.account.previewFlag == true){
          url = window._baseUrl + '/sport-odds-leagues-preview';
          if(this.getters.s_odd){
            url = window._baseUrl + '/sport-odds-preview';
          }
        }else{
          url = window._baseUrl + '/sport-odds-leagues';
          if(this.getters.s_odd){
            url = window._baseUrl + '/sport-odds';
          }
          if(this.getters.filter_select_all){
            if(this.getters.account.previewFlag == true){
              url = window._baseUrl + '/sport-odds-preview';
            }else{
              url = window._baseUrl + '/sport-odds';
            }
          }
        }
      }
      var schdl = data.schedule;
      //cdn checking
      if(url == window._baseUrl + '/sport-odds' || url == window._baseUrl + '/sport-odds-preview') {
        url += '/' + data.schedule
        httpMethod = 'get'
        data.gameMenuId = 0;
        delete data.leagues
        delete data.schedule
      }

      //if is show fav events
      if(payload.showfavorite!=undefined){
        this.commit('SPORT_SHOW_FAV_EVENTS', payload.showfavorite)
      } else {

      }

      if(this.getters.showFavEvents) {
        httpMethod = 'post'
        // _.unset(data, 'leagues')
        // data.events = this.getters.favouriteEvents[this.getters.selectedMarket][this.getters.arr_selectedTemplate.sportId]
        if(this.getters.favouriteEvents[this.getters.arr_selectedTemplate.sportId] && Object.keys(this.getters.favouriteEvents[this.getters.arr_selectedTemplate.sportId]).length>0){
          data.events = this.getters.favouriteEvents[this.getters.arr_selectedTemplate.sportId]
        } else {
          data.events = '0' //no event sel
        }
        if(this.getters.favouriteLgeEvents[this.getters.arr_selectedTemplate.sportId] && Object.keys(this.getters.favouriteLgeEvents[this.getters.arr_selectedTemplate.sportId]).length>0){
          data.lgevents = this.getters.favouriteLgeEvents[this.getters.arr_selectedTemplate.sportId]
        } else {
          data.lgevents = '0' //no event sel
        }
       
        url = window._baseUrl + '/sport-odds-favevents'
        
        if(data.token == undefined){
          data.token = window.token.arr_7;
        }
        data.showFav = '1'
        data.schedule = schdl;
      }
      //if is parlay show euro odds
      if(plytype == '5' && this.getters.account.oddsType!='am') {
        data.odd = this.getters.oddTypesList.EU.key
      }

      if(payload.sDate!=null){
        data.date = payload.sDate;
      }else{
        data.date = schedule == this.getters.market.earlyMarket.key ? this.getters.int_selectedParlayDate : '0'
        if(plytype == '5') {
          data.date = this.getters.int_selectedParlayDate
        }
      }
      //default for inplay and today
      data.plytypgrp = plytype
      if(plytype == '7' ||
        plytype == '8' ||
        plytype == '9' ||
        plytype == '10' ) {
            data.plytypgrp = '1'
      }

      if(data.plytypgrp == '2' && this.getters.int_fullHalfTime == '2') {
        data.plytypgrp = '6'
      } else if (data.plytypgrp == '3' && this.getters.int_fullHalfTime == '2') {
        data.plytypgrp = '7'
      }

      if(this.getters.editionStand == '0'){
        if(this.getters.simDisp == '4'){
          data.plytypgrp = '4'
        }else if(this.getters.simDisp == '6'){
          data.plytypgrp = '12'
        }
      }

      data.gameMenuId = 0;
      if(this.getters.isGameBannerSelected) {
        data.sprtid = this.getters.gameBannerSportId
        data.gameMenuId = this.getters.gameBannerId
      }
      
      //cdn checking
      if(url == window._baseUrl + '/sport-odds' || url == window._baseUrl + '/sport-odds-preview') {
        url += '/' + data.schedule
        httpMethod = 'get'
        delete data.schedule
      }
      
      core.$ajax({
        method: httpMethod,
        url: url,
        data: data
      }).done(((res)=> {
        var events = _.cloneDeep(res.events)
        var events_rb = _.cloneDeep(res.events_rb)
        var rbevents = _.cloneDeep(res.rbevents)
        var earlyParlayDateList = res.earlyParlayDateList
        
        if(!this.getters.s_odd && this.getters.arr_selectedLeague && this.getters.arr_selectedLeague.leagueid && res.events && res.events.length>0){
          var c = this.getters.arr_selectedLeague.c
          this.dispatch('selectLeague',{
            leagueid : res.events[0][0].lgeid,
            lgecapt: res.events[0][0].lgecapt,
            c: c
          })
        }
        if(this.getters.showFavEvents){
          this.commit('EVENTLIST',events)
          this.commit('TODAYRBEVENTLIST',rbevents)
        }else{
          this.commit('EVENTLIST',events)
          this.commit('TODAYRBEVENTLIST',events_rb)
        }
        if(this.getters.arr_selectedTemplate.subTemplateId=='4'){
          this.commit('CSODDSEVENT',events)
        }
        this.commit('TOTALPAGE', res.ttlPg)
        if(this.getters.selectedPage > res.ttlPg) {
          this.commit('SELECTED_PAGE', res.ttlPg)
        }
        if(res.earlyParlayDateList){
          this.commit('PARLAYDATELIST',earlyParlayDateList)
        }
        this.commit('LOADINGSCREEN', false)

        if(res.data && res.plyTyp) {
          this.commit('LEAGUE_LIST',res.data)
          this.commit('PLY_TYPE',res.plyTyp)
        }
        
        this.dispatch('sortEvents')

        if(payload&&payload.callback){
          return payload.callback(res)
        }
      }).bind(this)).catch((errRes)=> {
        console.log(errRes)
      })

        
    },
    getMarketTodayOdd(context, payload){
      let vue = this
      let havMatch = false
      this.dispatch('getTodayRBLaugueList',{
        enableLoading:true,
        token: payload.token,
        isGameBanner: 0,
        callback: (res) => {
          vue.dispatch('getTodayRBSportOdds', {
            loading: 1,
            token: token.arr_2,
            state: (vue.getters.selectedState)?vue.getters.selectedState:'',
            callback: (res) => {
              if(res&&res.events.length>0){
                havMatch = true
              }
            }
          }).then(()=>{
            havMatch = true
          })
        }
      }).then(()=>{
        havMatch = true
      })

      this.dispatch('getLaugueList', {
        enableLoading:true,
        token: payload.token,
        isGameBanner: 0,
        callback: (res) =>{
          vue.dispatch('getSportOdds', {
            loading: 1,
            token: token.arr_2,
            state: (vue.getters.selectedState)?vue.getters.selectedState:'',
            callback: (res) => {
              if(res&&res.events.length>0){
                havMatch = true
              }
            }
          }).then(()=>{
            havMatch = true
          })
        }
      }).then(()=>{
        havMatch = true
      })
      
      if(havMatch){
        this.dispatch('sortEvents')
      }
    },
    getSpecialEventOdds(context, payload){ 
      var leagueIds = []
      var httpMethod = 'post'

      // if(Object.keys(this.getters.arr_leagues).length > 0){
      //   _.forEach(this.getters.arr_leagues, function(res, key){
      //     leagueIds.push(res.leagueid)
      //   })
      //   this.commit('ARR_LEAGUES', [])
      // }else{
      //   this.dispatch('getLiveLeague', {
      //     enableLoading:true,
      //     token: token.arr_2,
      //   })
  
      //   _.forEach(this.getters.arr_specialEventLeague, function(res, key){
      //     leagueIds.push(res.id)
      //   })
      // }
      
      var bool_loading = true;           
      if(payload && payload.loading == '1'){
          bool_loading = false
      }

      var bettype =this.getters.arr_selectedTemplate.sportId;
      var plytype = this.getters.arr_selectedTemplate.plytype;
      var schedule = this.getters.int_marketToggle;
      var date = '0';

      if(payload && payload.livetv){ //livetv date change
          bettype = (payload.sportId)?payload.sportId:"";
          plytype = (payload.playType)?payload.playType:"";
          schedule = (payload.schedule)?payload.schedule:"";
          date = payload.sDate;
      }else{
        if(this.getters.int_selectedParlayDate && schedule == '2'){  
          date = this.getters.int_selectedParlayDate    
        }
      }
     
      if(this.getters.arr_selectedTemplate.subTemplateId == '2'){
        date = this.getters.int_selectedParlayDate    
        plytype = '5'
      }
    
      var data = {
        sprtid: bettype,
        schedule: schedule,
        lang: window._langid,
        spread: this.getters.account.spread,          
        odd: (this.getters.arr_selectedTemplate.subTemplateId == '2' && this.getters.account.oddsType!='am') ? this.getters.oddTypesList.EU.key: this.getters.account.oddsType,
        page: this.getters.selectedPage,
        sorttyp: 1,             
        date: date,
        plytypgrp : plytype,
        enableLoading: bool_loading,
        token: payload.token,
      }

      // if(this.getters.arr_selectedTemplate.leagueid ) {
      //   data.leagues = [this.getters.arr_selectedTemplate.leagueid]  
      // }else{
      //   data.leagues = leagueIds
      // }

      var url = window._baseUrl + '/sport-odds-leagues';
      if(this.getters.s_odd){
        url = window._baseUrl + '/sport-odds';
      }

      //cdn checking
      if(url == window._baseUrl + '/sport-odds') {
        url += '/' + data.schedule
        httpMethod = 'get'
        data.gameMenuId = 1;  //euro
        delete data.leagues
        delete data.schedule
      }
      
      // if(Object.keys(leagueIds).length > 0){
        core.$ajax({
          method: httpMethod,
          url: url,
          data: data
        }).done(((res)=> {   
          var events = _.cloneDeep(res.events)
          
          this.commit('EVENTLIST',events)
          this.commit('TOTALPAGE', res.ttlPg)
          if(this.getters.selectedPage > res.ttlPg) {
            this.commit('SELECTED_PAGE', res.ttlPg)
          }
          // this.commit('PARLAYDATELIST',earlyParlayDateList)
          this.dispatch('sortEvents')
          this.commit('FULL_LOAD', false)
          this.commit('SUBLOAD', false)
        }).bind(this)).catch((errRes)=> {
          console.log(errRes)
        })
      // }else{
      //   this.commit('FULL_LOAD', false)
      // }
    },
    getVipEventOdds(context, payload){ 
      var leagueIds = []
      var httpMethod = 'post'
      
      var bool_loading = true;           
      if(payload && payload.loading == '1'){
          bool_loading = false
      }

      var bettype =this.getters.arr_selectedTemplate.sportId;
      var plytype = this.getters.arr_selectedTemplate.plytype;
      var schedule = this.getters.int_marketToggle;
      var date = '0';

      if(payload && payload.livetv){ //livetv date change
          bettype = (payload.sportId)?payload.sportId:"";
          plytype = (payload.playType)?payload.playType:"";
          schedule = (payload.schedule)?payload.schedule:"";
          date = payload.sDate;
      }else{
        if(this.getters.int_selectedParlayDate && schedule == '2'){  
          date = this.getters.int_selectedParlayDate    
        }
      }
     
      if(this.getters.arr_selectedTemplate.subTemplateId == '2'){
        date = this.getters.int_selectedParlayDate    
        plytype = '5'
      }
    
      var data = {
        sprtid: bettype,
        schedule: schedule,
        lang: window._langid,
        spread: this.getters.account.spread,          
        odd: (this.getters.arr_selectedTemplate.subTemplateId == '2' && this.getters.account.oddsType!='am')  ? this.getters.oddTypesList.EU.key: this.getters.account.oddsType,
        page: this.getters.selectedPage,
        sorttyp: 1,             
        date: date,
        plytypgrp : plytype,
        enableLoading: bool_loading,
        token: payload.token,
      }

      var url = window._baseUrl + '/sport-odds-leagues';
      if(this.getters.s_odd){
        url = window._baseUrl + '/sport-odds';
      }

      //cdn checking
      if(url == window._baseUrl + '/sport-odds') {
        url += '/' + data.schedule
        httpMethod = 'get'
        data.gameMenuId = 99;  //VIP
        delete data.leagues
        delete data.schedule
      }
      
      // if(Object.keys(leagueIds).length > 0){
        core.$ajax({
          method: httpMethod,
          url: url,
          data: data
        }).done(((res)=> {   
          var events = _.cloneDeep(res.events)
          var earlyParlayDateList = res.earlyParlayDateList
          
          this.commit('EVENTLIST',events)
          this.commit('TOTALPAGE', res.ttlPg)
          if(this.getters.selectedPage > res.ttlPg) {
            this.commit('SELECTED_PAGE', res.ttlPg)
          }
          if(res.earlyParlayDateList){
            this.commit('PARLAYDATELIST',earlyParlayDateList)
          }
          this.dispatch('sortEvents')
          this.commit('FULL_LOAD', false)
          this.commit('SUBLOAD', false)
        }).bind(this)).catch((errRes)=> {
          console.log(errRes)
        })
      // }else{
      //   this.commit('FULL_LOAD', false)
      // }
    },
    sortEvents() {
      var vue = this
      var sortedEvents = _.cloneDeep(this.getters.arr_eventList)
      var sortedTodayRBEvents = _.cloneDeep(this.getters.arr_todayRBEventList)
      var newRBEvents = []
      var newSortedEvents = []
      var keyword = $('#searchInput').val().trim().toLowerCase()

      if(this.getters.arr_selectedTemplate.sportId!='G98' && (this.getters.int_marketToggle==1 || (this.getters.int_marketToggle==2 && this.getters.isParlay))){
        _.forEach(sortedTodayRBEvents, function(todayRbVal, todayRbKey){
          _.forEach(todayRbVal, function(val,key){
            var objStr = vue.getters.currentTab+'R'
            if(vue.getters.int_marketToggle == '3') {
              objStr = 'R'
            } 
            val['obj']=objStr+todayRbKey;
            if(_.isUndefined(vue.getters.isHideLeague[val['sptid']])){
              vue.getters.isHideLeague[val['sptid']]=false;
            }
            if(_.isUndefined(vue.getters.isCollapseMatch[val['sptid']])){
              vue.getters.isCollapseMatch[val['sptid']]=[];
            }
            if(vue.getters.isHideLeague[val['sptid']]==false && _.indexOf(vue.getters.isCollapseMatch[val['sptid']], val['obj'])>=0 && key!=0){
              // no draw
            }else if(vue.getters.isHideLeague[val['sptid']]==true && _.indexOf(vue.getters.isCollapseMatch[val['sptid']], val['obj'])<0 && key!=0){
              // no draw
            }else{
              newRBEvents.push(val)
            }
          })
        })
      }
      let load1st=0;
      if(this.getters.arr_selectedTemplate.subTemplateId!='3'){
        _.forEach(sortedEvents, function(sVal, sKey){
          _.forEach(sVal, function(val,key){
            var objStr = vue.getters.currentTab+'T'
            if(vue.getters.int_marketToggle == '3') {
              objStr = 'R'
            } 
            val['obj']=objStr+sKey;
            val['lastid']=0;
            if(_.isUndefined(vue.getters.isHideLeague[val['sptid']])){
              vue.getters.isHideLeague[val['sptid']]=false;
            }
            if(_.isUndefined(vue.getters.isCollapseMatch[val['sptid']])){
              vue.getters.isCollapseMatch[val['sptid']]=[];
            }
            if(vue.getters.isHideLeague[val['sptid']]==false && _.indexOf(vue.getters.isCollapseMatch[val['sptid']], val['obj'])>=0 && key!=0){
              // no draw
            }else if(vue.getters.isHideLeague[val['sptid']]==true && _.indexOf(vue.getters.isCollapseMatch[val['sptid']], val['obj'])<0 && key!=0){
              // no draw
            }else{
              if(load1st==0){
                val['lastid']=1;
                load1st=1;
              }
              if(!keyword 
                || (keyword && 
                  ((val.lgecapt && val.lgecapt.trim().toLowerCase().includes(keyword)) 
                    || (val.tacapt && val.tacapt.trim().toLowerCase().includes(keyword)) 
                    || (val.tbcapt && val.tbcapt.trim().toLowerCase().includes(keyword)))) 
                || (vue.getters.isHideLeague[val['sptid']]==false && _.indexOf(vue.getters.isCollapseMatch[val['sptid']], val['obj'])>=0 && key==0)) {
                  newSortedEvents.push(val)
                }
            }
          })
        })
        //newSortedEvents = _.sortBy(newSortedEvents, function(o){ return o.sptid; })
      }
      
      // if(this.getters.isOtr){
      //   var sortedOtrEvents = _.cloneDeep(this.getters.arr_otrEventList)
      //   var sortedFavOtrEvents = _.cloneDeep(sortedOtrEvents)
      //   this.commit('SORTEDFAVOTREVENTLIST', _.cloneDeep(sortedFavOtrEvents))
      //   if(this.getters.showFavEvents) {
      //     var lstId = ''
      //     var y = {}
      //     _.forEach(this.getters.sortedFavOtrEventList, function(val, eventKey){
      //       val.key = eventKey
      //       var otrFavOpStatus = true
      //       if(lstId == ''){
      //           lstId = val.lgeid
      //           vue.getters.sortedFavOtrEventList[eventKey]['subdis']=otrFavOpStatus;
      //           val.key = eventKey
      //       }else{
      //           if(lstId == val.lgeid){
      //               if(val.rbstatus==isRBStatus){
      //                 otrFavOpStatus = false
      //                 vue.getters.sortedFavOtrEventList[eventKey]['subdis']=otrFavOpStatus;
      //                 y.key = eventKey
      //                 y.lid = val.lgeid
      //                 if(!_.includes(vue.getters.otrHideFavTitleList, eventKey)){
      //                   vue.getters.otrHideFavTitleList.push(eventKey)
      //                 }
      //               }else{
      //                 otrFavOpStatus = true
      //                 vue.getters.sortedFavOtrEventList[eventKey]['subdis']=otrFavOpStatus;
      //                   val.key = eventKey
      //               }
      //           }else{
      //             vue.getters.sortedFavOtrEventList[eventKey]['subdis']=otrFavOpStatus;
      //             val.key = eventKey
      //           }
      //           lstId = val.lgeid
      //       }
      //       vue.commit('OTRHIDEFAVLGE_LIST', y)
      //     })
      //   }else{
      //     var lstId = ''
      //     var d = {}
      //     _.forEach(this.getters.sortedFavOtrEventList, function(val, eventKey){
      //       val.key = eventKey
      //       var otrOpStatus = true
      //       if(lstId == ''){
      //         lstId = val.lgeid
      //         vue.getters.sortedFavOtrEventList[eventKey]['subdis']=otrOpStatus;
      //         val.key = eventKey
      //       }else{
      //         if(lstId == val.lgeid){
      //           if(val.rbstatus==isRBStatus){
      //             otrOpStatus = false
      //             vue.getters.sortedFavOtrEventList[eventKey]['subdis']=otrOpStatus;
      //             d.key = eventKey
      //             d.lid = val.lgeid
      //             if(!_.includes(vue.getters.otrHideTitleList, eventKey)){
      //               vue.getters.otrHideTitleList.push(eventKey)
      //             }
      //           }else{
      //             otrOpStatus = true
      //             vue.getters.sortedFavOtrEventList[eventKey]['subdis']=otrOpStatus;
      //             val.key = eventKey
      //           }
      //         }else{
      //             vue.getters.sortedFavOtrEventList[eventKey]['subdis']=otrOpStatus;
      //             val.key = eventKey
      //         }
      //         lstId = val.lgeid
      //       }
      //       vue.commit('OTRHIDELGE_LIST', d)
      //     })
      //   }
      // }
      // this.commit('SORTEDEVENTLIST', _.cloneDeep(sortedEvents))
      if(this.getters.int_marketToggle=='1' || (this.getters.int_marketToggle==2 && this.getters.isParlay)){
        sortedEvents = _.concat(newRBEvents, newSortedEvents)
      }else if(this.getters.arr_selectedTemplate.subTemplateId!='3'){// if(this.getters.arr_selectedTemplate.sportId!='G98')
        sortedEvents = newSortedEvents
      }

      this.commit('SORTEDEVENTLIST', _.cloneDeep(sortedEvents))
      this.commit('SORTEDTODAYRBEVENTLIST', _.cloneDeep(newRBEvents))

      var lastId = ''
      var lastIdDt = ''
      _.forEach(this.getters.sortedEvents, function(val, eventKey){
        val.key = eventKey
        if(lastId != val.lgeid || lastIdDt!=val.dt) {
          lastId = val.lgeid
          lastIdDt = val.dt
          vue.getters.sortedEvents[eventKey]['subdis']=true;
        } else {
          vue.getters.sortedEvents[eventKey]['subdis']=false;
        }
      })
      
      if(this.getters.editionStand == 1){
        if(this.getters.arr_selectedTemplate.sportId == 'G98'){
          if(this.getters.showFavEvents){
            EventBus.$emit('reloadFavComputed')
          }else{
            EventBus.$emit('reloadAllComputed')
          }
        }else{
          if(this.getters.showFavEvents){
            EventBus.$emit('reloadFavComputed')
          }else{
            EventBus.$emit('reloadComputed')
          }
        }
      }else if(this.getters.editionStand == 0){
        if(this.getters.arr_selectedTemplate.sportId == 'G98'){
          if(this.getters.showFavEvents){
            EventBus.$emit('reloadFavSimpleComputed')
          }else{
            EventBus.$emit('reloadSimpleAllComputed')
          }
        }else{
          if(this.getters.showFavEvents){
            EventBus.$emit('reloadFavSimpleComputed')
          }else{
            EventBus.$emit('reloadSimpleComputed')
          }
        }
      }else if(this.getters.editionStand == 2){
        if(this.getters.arr_selectedTemplate.sportId == 'G98'){
          if(this.getters.showFavEvents){
            EventBus.$emit('reloadFavExpandComputed')
          }else{
            EventBus.$emit('reloadExpandAllComputed')
          }
        }else{
          if(this.getters.showFavEvents){
            EventBus.$emit('reloadFavExpandComputed')
          }else{
            EventBus.$emit('reloadExpandComputed')
          }
        }
      }else if(this.getters.editionStand == 3){
        if(this.getters.arr_selectedTemplate.sportId == 'G98'){
          if(this.getters.showFavEvents){
            EventBus.$emit('reloadFavExpandComputed')
          }else{
            EventBus.$emit('reloadSimpleSoccerComputed')
          }
        }else{
          if(this.getters.showFavEvents){
            EventBus.$emit('reloadFavSSComputed')
          }else{
            EventBus.$emit('reloadSimpleSoccerComputed')
          }
        }
      }
        
      if(this.getters.showFavEvents){
        var sortedFavRbEvents = _.cloneDeep(sortedEvents)
        this.commit('SORTEDFAVRBEVENTLIST', _.cloneDeep(sortedFavRbEvents))
      }
  
      if(this.getters.favouriteEvents && Object.keys(this.getters.favouriteEvents).length > 0){
        
        if(this.getters.arr_selectedTemplate.subTemplateId == '3'){
          this.dispatch('sortFavouriteOtrEvents', {
            orderedEvents: state.sortedFavOtrEventList,
            callback: ((res) => {
              if(this.getters.showFavEvents){
                var sortedFavOtrEvents = _.filter(res, function(o){
                  return _.includes(vue.getters.favouriteEvents[vue.getters.arr_selectedTemplate.sportId], o.eveid)
                })
                this.commit('SORTEDFAVOTREVENTLIST', _.cloneDeep(sortedFavOtrEvents))
              }else{
                this.commit('SORTEDFAVOTREVENTLIST', _.cloneDeep(res))
              }
            })
          })
        }else{
          this.dispatch('sortFavouriteEvents', {
            orderedEvents: state.sortedEvents,
            callback: ((res) => {
              this.commit('SORTEDEVENTLIST', _.cloneDeep(res))
            })
          })
        }
  
        if(state.sortedFavRbEventList){
          this.dispatch('sortFavouriteEvents', {
            orderedEvents: state.sortedFavRbEventList,
            callback: ((res) => {
              this.commit('SORTEDFAVRBEVENTLIST', _.cloneDeep(res))
            })
          })
        }
      }
      this.commit('REFRESH_SPORTTABLE', false)
      this.commit('REFRESHSCREEN', false)
    },
    getLiveSportOdds(context, payload){ 
      var liveLeagueIds = []
      // if(Object.keys(this.getters.arr_leagues).length > 0){
      //   _.forEach(this.getters.arr_leagues, function(res, key){
      //     liveLeagueIds.push(res.leagueid)
      //   })
      //   this.commit('ARR_LEAGUES', [])
      // }else{
      //   if(!this.getters.selectedMatches && !this.getters.s_odd){
      //     this.dispatch('getLiveLeague', {
      //       enableLoading:true,
      //       token: token.arr_2,
      //       // state: (payload.state)?payload.state:''
      //     })

      //     _.forEach(this.getters.arr_liveLeague, function(res, key){
      //       liveLeagueIds.push(res.id)
      //     })
      //   }else{
      //     if(payload.state && payload.state != ''){
      //       this.dispatch('getLiveLeague', {
      //         enableLoading:true,
      //         token: token.arr_2,
      //         state: (payload.state)?payload.state:''
      //       })
            
      //       _.forEach(this.getters.arr_liveLeague, function(res, key){
      //         liveLeagueIds.push(res.id)
      //       })
      //     }else{
      //       this.dispatch('getLiveLeague', {
      //         enableLoading:true,
      //         token: token.arr_2,
      //         // state: (payload.state)?payload.state:''
      //       })
  
      //       _.forEach(this.getters.arr_liveLeague, function(res, key){
      //         liveLeagueIds.push(res.id)
      //       })
      //     }
      //   }
      // }
      
      var bool_loading = true;           
      if(payload && payload.loading == '1'){
          bool_loading = false
      }
      var isSportOdd = false
      var bettype =this.getters.arr_selectedTemplate.sportId;
      var plytype = this.getters.arr_selectedTemplate.plytype;
      var schedule = this.getters.int_marketToggle;
      var date = '0';

      if(payload && payload.livetv){ //livetv date change
          bettype = (payload.sportId)?payload.sportId:"";
          plytype = (payload.playType)?payload.playType:"";
          schedule = (payload.schedule)?payload.schedule:"";
          date = payload.sDate;
      }else{
        if(this.getters.int_selectedParlayDate && (schedule == '2' || schedule == '1')){  
          date = this.getters.int_selectedParlayDate    
        }
      }
     
      if(this.getters.arr_selectedTemplate.subTemplateId == '2'){
        date = this.getters.int_selectedParlayDate    
        plytype = '5'
      }
      
      // if(this.getters.gameBannerId && this.getters.editionStand == '3') {
      //   bettype = 'G3'
      // }
      
      var data = {
        sprtid: bettype,
        schedule: schedule,
        lang: window._langid,
        spread: this.getters.account.spread,          
        odd: (this.getters.arr_selectedTemplate.subTemplateId == '2' && this.getters.account.oddsType!='am')  ? this.getters.oddTypesList.EU.key: this.getters.account.oddsType,
        page: 0, // this.getters.selectedPage,
        sorttyp: this.getters.selectedSort,
        date: date,
        sdate: this.getters.selected_date,
        timezone: this.getters.selected_timezone,
        plytypgrp : plytype,
        enableLoading: bool_loading,
        token: payload.token,
      }
      
      //if show league
      // if(this.getters.arr_selectedLeague){
      //   if(this.getters.arr_selectedLeague.leagueid ) {
      //     data.leagues = [this.getters.arr_selectedLeague.leagueid]  
      //   }
      // }
      // if(this.getters.arr_selectedTemplate){
      if(!this.getters.showFavEvents){
        if(this.getters.arr_selectedTemplate.leagueid ) {
          data.leagues = [this.getters.arr_selectedTemplate.leagueid]  
        }else{
          data.leagues = liveLeagueIds
        }
      }
      // }
      var httpMethod = 'post'
      var url = ''
      if(this.getters.account.previewFlag == true){
        url = window._baseUrl + '/sport-odds-leagues-preview';
        if(this.getters.s_odd){
          url = window._baseUrl + '/sport-odds-preview';
        }
      }else{
        url = window._baseUrl + '/sport-odds-leagues';
        if(this.getters.s_odd){
          url = window._baseUrl + '/sport-odds';
        }
      }

      //if is show fav events
      if(payload.showfavorite!=undefined){
        this.commit('SPORT_SHOW_FAV_EVENTS', payload.showfavorite)
      } else {

      }

      if(this.getters.showFavEvents) {
        // _.unset(data, 'leagues')
        // data.events = this.getters.favouriteEvents[this.getters.selectedMarket][this.getters.arr_selectedTemplate.sportId]
        if(this.getters.favouriteEvents[this.getters.arr_selectedTemplate.sportId] && Object.keys(this.getters.favouriteEvents[this.getters.arr_selectedTemplate.sportId]).length>0){
          data.events = this.getters.favouriteEvents[this.getters.arr_selectedTemplate.sportId]
        } else {
          data.events = '0' //no event sel
        }
        if(this.getters.favouriteLgeEvents[this.getters.arr_selectedTemplate.sportId] && Object.keys(this.getters.favouriteLgeEvents[this.getters.arr_selectedTemplate.sportId]).length>0){
          data.lgevents = this.getters.favouriteLgeEvents[this.getters.arr_selectedTemplate.sportId]
        } else {
          data.lgevents = '0' //no event sel
        }
       
        url = window._baseUrl + '/sport-odds-favevents'
        
        if(data.token == undefined){
          data.token = window.token.arr_7;
        }
        data.showFav = '1'
      }
      
      //cdn checking
      if(url == window._baseUrl + '/sport-odds' || url == window._baseUrl + '/sport-odds-preview') {
        url += '/' + data.schedule
        isSportOdd = true
        httpMethod = 'get'
        data.gameMenuId = 0;
        delete data.leagues
        delete data.schedule
      }

      if(this.getters.isGameBannerSelected) {
        data.sprtid = this.getters.gameBannerSportId
        data.gameMenuId = this.getters.gameBannerId
      }

      if(this.getters.editionStand == '0'){
        if(this.getters.simDisp == '4'){
          data.plytypgrp = '4'
        }else if(this.getters.simDisp == '6'){
          data.plytypgrp = '12'
        }
      }
      
      if(Object.keys(liveLeagueIds).length > 0 || (isSportOdd && Object.keys(liveLeagueIds).length==0) || this.getters.showFavEvents){
        core.$ajax({
          method: httpMethod,
          url: url,
          data: data
        }).done(((res)=> {
          
          if(this.getters.showFavEvents){
            var events = _.cloneDeep(res.rbevents)  
          }else{
            var events = _.cloneDeep(res.events)
          }
          // var earlyParlayDateList = res.earlyParlayDateList
          // if(res.events){
          //   var c = this.getters.arr_selectedLeague.c
          //   this.dispatch('selectLeague',{
          //     leagueid : res.events[0][0].lgeid,
          //     lgecapt: res.events[0][0].lgecapt,
          //     c: c
          //   })
          // }
          this.commit('EVENTLIST',events)
          if(this.getters.arr_selectedTemplate.subTemplateId=='4'){
            this.commit('CSODDSEVENT',events)
          }
          this.commit('TOTALPAGE', res.ttlPg)
          if(this.getters.selectedPage > res.ttlPg) {
            this.commit('SELECTED_PAGE', res.ttlPg)
          }
          // this.commit('PARLAYDATELIST',earlyParlayDateList)
          this.dispatch('sortEvents')
          this.commit('FULL_LOAD', false)
        }).bind(this)).catch((errRes)=> {
          console.log(errRes)
        })
      }else{
        this.commit('FULL_LOAD', false)
      }

        
    },
    getLiveLeague(context, payload){
      var date = this.getters.int_selectedParlayDate
      if(this.getters.int_marketToggle == '1' || this.getters.int_marketToggle == '3'){
        date = '0'
      }
      var plytypgrp = '1'
      if(this.getters.arr_selectedTemplate.subTemplateId == '2'){
        date = this.getters.int_selectedParlayDate
        plytypgrp = '5'
      }
      
      var gameMenuId = 0
      if(this.getters.isSpecial) { //special event(eg: EURO 2020)
        gameMenuId = 1
      } else if(this.getters.isGameBannerSelected) {
        gameMenuId = this.getters.gameBannerId
      }

      var url = ''
      if(this.getters.account.previewFlag == true){
        url = _baseUrl + '/sport-league-list-preview';
      }else{
        url = _baseUrl + '/sport-league-list';
      }
      EventBus.$emit('enableLoading', false)
      
      core.$ajax({
        method: 'get',
        url: url,
        data: {
          sprtid: this.getters.isGameBannerSelected?this.getters.gameBannerSportId:this.getters.arr_selectedTemplate.sportId,
          schedule: this.getters.arr_selectedTemplate.marketKey,
          date: date,
          plytypgrp: plytypgrp,
          langId: window._langid,
          sort: this.getters.selectedSort,
          spread: this.getters.account.spread,          
          gameMenuId: gameMenuId,
          enableLoading: payload && payload.enableLoading ? payload.enableLoading : false,
          token: payload.token,
        },
        async: false
      }).done(((res)=> {
        
        let dat = res.leagues

        if(payload.state && payload.state != ''){
          dat = _.filter(res.leagues, function(o) {
            if(o.state == payload.state){
              return true
            }
          })
        }
        
        EventBus.$emit('enableLoading', false)
        this.commit('SUBLOAD', false)
        if(this.getters.int_marketToggle == '3'){
          this.commit('LIVELEAGUE', dat)
        } else { //special event(eg: EURO 2020)
          if(this.getters.int_marketToggle == '1' || this.getters.int_marketToggle == '2'){
            this.commit('LIVELEAGUE', dat)
          }else{
            this.commit('SPECIAL_EVENTLIST', dat)
          }
          //this.commit('LEAGUELIST', res.leagues)
        }
        // this.commit('PARLAYDATELIST', res.earlyParlayDateList)
        if(payload && payload.callback) {
          return payload.callback(res)
        }
      }).bind(this)).catch((errRes)=> {
        console.log(errRes)
      })
    },
    getParlayOdds(context, payload){ 
      
      var liveLeagueIds = []
      this.dispatch('getParlayTdyLeague', {
        enableLoading:true,
        token: token.arr_2,
        state: payload.state,
      })
      
      _.forEach(this.getters.arr_liveLeague, function(res, key){
        liveLeagueIds.push(res.id)
      })
      
      var bool_loading = true;           
      if(payload && payload.loading == '1'){
          bool_loading = false
      }

      var bettype =this.getters.arr_selectedTemplate.sportId;
      var plytype = this.getters.arr_selectedTemplate.plytype;
      var schedule = this.getters.int_marketToggle;
      var date = '0';

      if(payload && payload.livetv){ //livetv date change
          bettype = (payload.sportId)?payload.sportId:"";
          plytype = (payload.playType)?payload.playType:"";
          schedule = (payload.schedule)?payload.schedule:"";
          date = payload.sDate;
      }else{
        if(this.getters.int_selectedParlayDate && (schedule == '2' || schedule == '1')){  
          date = this.getters.int_selectedParlayDate    
        }
      }
     
      if(this.getters.arr_selectedTemplate.subTemplateId == '2' || this.getters.isParlay){
        date = this.getters.int_selectedParlayDate    
        plytype = '5'
      }
      
      // if(this.getters.gameBannerId && this.getters.editionStand == '3') {
      //   bettype = 'G3'
      // }
      
      var data = {
        sprtid: bettype,
        schedule: schedule,
        lang: window._langid,
        spread: this.getters.account.spread,          
        odd: (this.getters.isParlay && this.getters.account.oddsType!='am')  ? this.getters.oddTypesList.EU.key: this.getters.account.oddsType,
        page: 1,
        sorttyp: this.getters.selectedSort,             
        date: date,
        plytypgrp : plytype,
        enableLoading: bool_loading,
        token: payload.token,
      }
      //if show league
      // if(this.getters.arr_selectedLeague){
      //   if(this.getters.arr_selectedLeague.leagueid ) {
      //     data.leagues = [this.getters.arr_selectedLeague.leagueid]  
      //   }
      // }
      // if(this.getters.arr_selectedTemplate){
        if(this.getters.arr_selectedTemplate.leagueid ) {
          data.leagues = [this.getters.arr_selectedTemplate.leagueid]  
        }else{
          data.leagues = liveLeagueIds
        }
      // }
      var httpMethod = 'post'
      var url = ''
      if(this.getters.account.previewFlag == true){
        url = window._baseUrl + '/sport-odds-leagues-preview';
        if(this.getters.s_odd){
          url = window._baseUrl + '/sport-odds-preview';
        }
      }else{
        url = window._baseUrl + '/sport-odds-leagues';
        if(this.getters.s_odd){
          url = window._baseUrl + '/sport-odds';
        }
      }

      //cdn checking
      if(url == window._baseUrl + '/sport-odds' || url == window._baseUrl + '/sport-odds-preview') {
        url += '/' + data.schedule
        httpMethod = 'get'
        data.gameMenuId = 0;
        delete data.schedule
      }
      
      if(Object.keys(liveLeagueIds).length > 0){
        core.$ajax({
          method: httpMethod,
          url: url,
          data: data
        }).done(((res)=> {
          var events = _.cloneDeep(res.events)
          // var earlyParlayDateList = res.earlyParlayDateList
          // if(res.events){
          //   var c = this.getters.arr_selectedLeague.c
          //   this.dispatch('selectLeague',{
          //     leagueid : res.events[0][0].lgeid,
          //     lgecapt: res.events[0][0].lgecapt,
          //     c: c
          //   })
          // }
          this.commit('EVENTLIST',events)
          // this.commit('PARLAYDATELIST',earlyParlayDateList)
          this.dispatch('sortEvents')
        }).bind(this)).catch((errRes)=> {
          console.log(errRes)
        })
      }
    },
    getParlayLeague(context, payload){
      this.dispatch('getParlayEarlyLeague', {
        enableLoading:true,
        token: payload.token,
        state: payload.state,
      })
    },
    getParlayEarlyLeague(context, payload){
      var date = '99'
      var plytypgrp = '1'
      if(this.getters.arr_selectedTemplate.templateId == '21'){
        date = this.getters.int_selectedParlayDate
        plytypgrp = '5'
      }

      var url = ''
      if(this.getters.account.previewFlag == true){
        url = _baseUrl + '/sport-league-list-preview';
      }else{
        url = _baseUrl + '/sport-league-list';
      }
      
      this.commit('FULL_LOAD', true)
      core.$ajax({
        method: 'get',
        url: url,
        data: {
          sprtid: this.getters.arr_selectedTemplate.sportId,
          schedule: this.getters.int_marketToggle,
          date: date,
          plytypgrp: plytypgrp,
          langId: window._langid,
          sort: this.getters.selectedSort,
          spread: this.getters.account.spread,          
          gameMenuId: this.getters.isGameBannerSelected?this.getters.gameBannerId:0,
          enableLoading: payload && payload.enableLoading ? payload.enableLoading : false,
          token: payload.token,
        }
      }).done(((res)=> {
        let dat = res.leagues
        let stateArr = []

        $.each(dat, function(key, val){
          if(!_.includes(stateArr, val.state)){
            stateArr.push(val.state)
          }
        })
        this.commit('STATE_LIST', stateArr)

        if(payload.state && payload.state != ''){
          dat = _.filter(res.leagues, function(o) {
            if(o.state == payload.state){
              return true
            }
          })
        }

        this.commit('LEAGUELIST', dat)
        if(res.earlyParlayDateList){
          this.commit('PARLAYDATELIST', res.earlyParlayDateList)
        }
        this.commit('FULL_LOAD', false)

        if(Object.keys(res.leagues).length>0){
          this.dispatch('getSportOdds', {
            loading: 1,
            token: token.arr_2,
            state: (this.getters.selectedState)?this.getters.selectedState:'',
          })
        } else {
          this.commit('REFRESHSCREEN', false)
        }
        if(payload && payload.callback) {
          return payload.callback(res)
        }
      }).bind(this)).catch((errRes)=> {
        console.log(errRes)
      })
    },
    getParlayTdyLeague(context, payload){
      var date = '0'

      var plytypgrp = '5'
      // if(this.getters.arr_selectedTemplate.templateId == '21'){
        // date = this.getters.int_selectedParlayDate
        // plytypgrp = '5'
      // }

      var url = ''
      if(this.getters.account.previewFlag == true){
        url = _baseUrl + '/sport-league-list-preview';
      }else{
        url = _baseUrl + '/sport-league-list';
      }
      
      core.$ajax({
        method: 'get',
        url: url,
        data: {
          sprtid: this.getters.arr_selectedTemplate.sportId,
          schedule: 1,
          date: date,
          plytypgrp: plytypgrp,
          langId: window._langid,
          sort: this.getters.selectedSort,
          spread: this.getters.account.spread,          
          gameMenuId: 0,
          enableLoading: payload && payload.enableLoading ? payload.enableLoading : false,
          token: payload.token,
        },
      }).done(((res)=> {
        let dat = res.leagues

        if(payload.state && payload.state != ''){
          dat = _.filter(res.leagues, function(o) {
            if(o.state == payload.state){
              return true
            }
          })
        }

        this.commit('LIVELEAGUE', dat)
        if(res.earlyParlayDateList){
          this.commit('PARLAYDATELIST', res.earlyParlayDateList)
        }
        if(payload && payload.callback) {
          return payload.callback(res)
        }
      }).bind(this)).catch((errRes)=> {
        console.log(errRes)
      })
    },
    sortFavouriteEvents(orderedEvents, payload) {

      let vue = this
      _.forEach(payload.orderedEvents, ((event, key) => {
        if(!_.isUndefined(state.favouriteEvents)){
          if(_.indexOf(state.favouriteLgeEvents[vue.getters.selectedSport], event.lgeid) >= 0 ) {
            event.isFavourite = true
          } else {
            if(_.indexOf(state.favouriteEvents[vue.getters.selectedSport], event.eveid) >= 0 ) {
              event.isFavourite = true
            } else {
              event.isFavourite = false
            }
          }
        }
      }))
      payload.callback(payload.orderedEvents)
    },
    sortFavouriteOtrEvents(orderedEvents, payload) {
      let vue = this
      
      _.forEach(payload.orderedEvents, ((event, key) => {
        if(!_.isUndefined(state.favouriteEvents)){
          if(_.indexOf(state.favouriteLgeEvents[vue.getters.arr_selectedTemplate.sportId], event.lgeid) >= 0 ) {
            event.isFavourite = true
          } else {
            if(_.indexOf(state.favouriteEvents[vue.getters.arr_selectedTemplate.sportId], event.eveid) >= 0 ) {
              event.isFavourite = true
            } else {
              event.isFavourite = false
            }
          }
        }
      }))
      payload.callback(payload.orderedEvents)
    },
    allBetFavouriteEvents(orderedEvents, payload) {
      let vue = this
      if(!_.isUndefined(state.favouriteEvents)){
        if(_.indexOf(state.favouriteLgeEvents[vue.getters.selectedSport], payload.orderedEvents.lgeid) >= 0 ) {
          payload.orderedEvents.isFavourite = true
        } else {
          if(_.indexOf(state.favouriteEvents[vue.getters.selectedSport], payload.orderedEvents.eveid) >= 0 ) {
            payload.orderedEvents.isFavourite = true
          } else {
            payload.orderedEvents.isFavourite = false
          }
        }
      }
      payload.callback(payload.orderedEvents)
    },
    sortFavouriteMatchEvents(orderedEvents, payload) {
      let vue = this
      if(payload.orderedEvents){
        if(!_.isUndefined(state.favouriteEvents)){
          if(_.indexOf(state.favouriteEvents[vue.getters.selectedSport], payload.orderedEvents.eveid) >= 0 ) {
            payload.orderedEvents.isFavourite = true
          } else {
            payload.orderedEvents.isFavourite = false
          }
        }
      }
  
      payload.callback(payload.orderedEvents)
    },
}

// mutations
const mutations = {
    [types.EVENTLIST] (state, payload ) {
      state.arr_eventList = payload
    },
    [types.OTREVENTLIST] (state, payload ) {
      state.arr_otrEventList = payload
    },
    [types.SELECTED_SORT] (state, payload){
      state.selectedSort = payload
    },
    [types.SORTEDEVENTLIST](state, payload ){
        state.sortedEvents = payload
    },
    [types.LIVELEAGUE] (state, payload ) {
      state.arr_liveLeague = payload
    },
    [types.LIVE_EVENTLIST] (state, payload ) {
      state.arr_liveEventList = payload
    },
    [types.PARLAY_TDYEVENTLIST] (state, payload ) {
      state.arr_parlayTdyEventList = payload
    },
    [types.PARLAY_EARLYEVENTLIST] (state, payload ) {
      state.arr_parlayEarlyEventList = payload
    },
    [types.SPECIAL_EVENTLIST](state, payload) {
      state.arr_specialEventLeague = payload
    },
    [types.SELECTED_STATE] (state, payload) {
      state.selectedState = payload
    },
    [types.STATE_LIST] (state, payload) {
      state.stateList = payload
    },
    [types.FAVOURITEEVENT] (state, payload ) {

      if(payload.clear) {
        state.favouriteEvents = payload.clear ? {} : state.favouriteEvents
        state.showFavEvents = false
        _.forEach(state.sortedEvents, ((events, eventsKey) => {
          _.forEach(events, ((event, eventKey) => {
            state.sortedEvents[eventsKey][eventKey].isFavourite = false
          }))
        }))
        if(state.sortedMatchEventList){
          if(state.sortedMatchEventList.eveid == payload.event.eveid) {
            state.sortedMatchEventList.isFavourite = false
          }
        }
      } else {
        let VUE = this
        function recursiveMethod(value, type, league){
          var selectedMarket = VUE.getters.selectedMarket
          var selectedSport = VUE.getters.arr_selectedTemplate.sportId
          if(value == null && type =='market') {
            value = {}
            return recursiveMethod(value, 'sport', league)
          }
          if(value == null){
            return recursiveMethod(value, 'market', league)
          }
          if(value[selectedSport] == null){
            value[selectedSport] = []
            value[selectedSport].push(league)
            return value
          }
          value[selectedSport].push(league)
          return value;
        }
        let LgeCheck=false;
        if(!_.isUndefined(state.favouriteLgeEvents) && _.indexOf(state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId], payload.event.lgeid) >= 0) {
          _.pull(state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId], payload.event.lgeid);
          let EveList=payload.isrb?state.sortedFavRbEventList:state.sortedEvents;
          _.forEach(EveList, ((events, eventsKey) => {
            _.forEach(events, ((event, eventKey) => {
              if(event.eveid != payload.event.eveid && event.lgeid==payload.event.lgeid) { // checked the event in league
                if(Object.keys(state.favouriteEvents).length <= 0){
                  state.favouriteEvents = {}
                  state.favouriteEvents[VUE.getters.arr_selectedTemplate.sportId] = [event.eveid]
                }else{
                  var fav = recursiveMethod(state.favouriteEvents, 'market', event.eveid)
                }
              }else if(event.eveid == payload.event.eveid && event.lgeid==payload.event.lgeid) {
                LgeCheck=true;
              }
            }))
          }))
          if(state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId].length <= 0){
            delete state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId]
            if(Object.keys(state.favouriteLgeEvents).length <= 0){
              state.favouriteLgeEvents = {} 
            }
          }
        }
        if(!_.isUndefined(state.favouriteEvents) && _.indexOf(state.favouriteEvents[VUE.getters.arr_selectedTemplate.sportId], payload.event.eveid) >= 0) {
          _.pull(state.favouriteEvents[VUE.getters.arr_selectedTemplate.sportId], payload.event.eveid)
          if(state.favouriteEvents[VUE.getters.arr_selectedTemplate.sportId].length <= 0){
            delete state.favouriteEvents[VUE.getters.arr_selectedTemplate.sportId]
            if(Object.keys(state.favouriteEvents).length <= 0){
              state.favouriteEvents = {} 
            }
          }
        } else if(!LgeCheck){
          if(Object.keys(state.favouriteEvents).length <= 0){
            state.favouriteEvents = {}
            state.favouriteEvents[VUE.getters.arr_selectedTemplate.sportId] = [payload.event.eveid]
          }else{
            var fav = recursiveMethod(state.favouriteEvents, 'market', payload.event.eveid)
          }
        }
        
        //alert(JSON.stringify(state.favouriteEvents))
        if(payload.isrb){
          _.forEach(state.sortedFavRbEventList, ((events, eventsKey) => {
            _.forEach(events, ((event, eventKey) => {
              if(event.eveid == payload.event.eveid) {
                if(!payload.event.isFavourite) {
                  state.sortedFavRbEventList[eventsKey][eventKey].isFavourite = true
                } else {
                  state.sortedFavRbEventList[eventsKey][eventKey].isFavourite = !payload.event.isFavourite
                }
              }
            }))
          }))
        } else {
          _.forEach(state.sortedEvents, ((events, eventsKey) => {
            _.forEach(events, ((event, eventKey) => {
              if(event.eveid == payload.event.eveid) {
                if(!payload.event.isFavourite) {
                  state.sortedEvents[eventsKey][eventKey].isFavourite = true
                } else {
                  state.sortedEvents[eventsKey][eventKey].isFavourite = !payload.event.isFavourite
                }
              }
            }))
          }))
        }
        
        if(state.sortedMatchEventList){
          if(state.sortedMatchEventList.eveid == payload.event.eveid) {
            if(!payload.event.isFavourite) {
              state.sortedMatchEventList.isFavourite = true
            } else {
              state.sortedMatchEventList.isFavourite = !payload.event.isFavourite
            }
          }
        }
        if(VUE.getters.arr_selectedTemplate.subTemplateId == '3'){
          this.dispatch('sortFavouriteOtrEvents', {
            orderedEvents: state.sortedEvents,
            callback: ((res) => {
              this.commit('SORTEDEVENTLIST', _.cloneDeep(res))
            })
          })
        }else{
          this.dispatch('sortFavouriteEvents', {
            orderedEvents: state.sortedEvents,
            callback: ((res) => {
              this.commit('SORTEDEVENTLIST', _.cloneDeep(res))
            })
          })
        }
        this.dispatch('sortFavouriteMatchEvents', {
          orderedEvents: state.sortedMatchEventList,
          callback: ((res) => {
            this.commit('SORTEDMATCHEVENTLIST', _.cloneDeep(res))
          })
        })
      }
    },
    [types.SELECTED_BETTYPE] (state, payload ) {
      state.selectedBettype = payload
    },
    [types.SORTEDMATCHEVENTLIST] (state, payload ) {
      state.sortedMatchEventList = payload
    },
    [types.SORTEDFAVRBEVENTLIST] (state, payload ) {
      state.sortedFavRbEventList = payload
    },
    [types.SPORT_SHOW_FAV_EVENTS] (state, payload ) {
      state.showFavEvents = payload
    },
    [types.FAVOURITEALLBETEVENT] (state, payload ) {
      let VUE = this
      const eveid = payload.event.eveid;
      const sport = this.getters.selectedSport;

      if (!state.favouriteEvents[sport]) {
        state.favouriteEvents[sport] = [];
      }

      const index = state.favouriteEvents[sport].indexOf(eveid);

      if (index >= 0) { // remove
        state.favouriteEvents[sport].splice(index, 1);
        if (state.favouriteEvents[sport].length === 0) {
          delete state.favouriteEvents[sport];
        }
      } else { // add
        state.favouriteEvents[sport].push(eveid);
      }

      if (Object.keys(state.favouriteEvents).length === 0) {
        state.favouriteEvents = {};
      }
      
      this.dispatch('allBetFavouriteEvents', {
        orderedEvents: VUE.getters.arr_allBetEvent,
        callback: ((res) => {
          this.commit('ALLBETEVENT', _.cloneDeep(res))
        })
      })
    },
    [types.SORTEDFAVOTREVENTLIST] (state, payload){
      state.sortedFavOtrEventList = payload
    },
    [types.TODAYRBEVENTLIST] (state, payload ) {
      state.arr_todayRBEventList = payload
    },
    [types.SORTEDTODAYRBEVENTLIST](state, payload ){
        state.sortedTodayRBEvents = payload
    },
    [types.HIDE_STATUS] (state, payload) {
      state.hideLegHeader = payload
    },
    [types.LABEL_STATUS] (state, payload) {
      state.lableHeader = payload
    },
    [types.SETFAVOURITE] (state, payload) {
      const eveid = payload.event.eveid;
      const sport = this.getters.selectedSport;

      if (!state.favouriteEvents[sport]) {
        state.favouriteEvents[sport] = [];
      }

      const index = state.favouriteEvents[sport].indexOf(eveid);

      if (index >= 0) { // remove
        state.favouriteEvents[sport].splice(index, 1);
        if (state.favouriteEvents[sport].length === 0) {
          delete state.favouriteEvents[sport];
        }
      } else { // add
        state.favouriteEvents[sport].push(eveid);
      }

      if (Object.keys(state.favouriteEvents).length === 0) {
        state.favouriteEvents = {};
      }

      // if(VUE.getters.arr_selectedTemplate.subTemplateId == '3'){
      //   this.dispatch('sortFavouriteOtrEvents', {
      //     orderedEvents: state.sortedFavOtrEventList,
      //     callback: ((res) => {
      //       this.commit('SORTEDFAVOTREVENTLIST', _.cloneDeep(res))
      //     })
      //   })
      // }else{
        this.dispatch('sortFavouriteEvents', {
          orderedEvents: state.sortedEvents,
          callback: ((res) => {
            this.commit('SORTEDEVENTLIST', _.cloneDeep(res))
          })
        })
      // }
      this.dispatch('sortFavouriteMatchEvents', {
        orderedEvents: state.sortedMatchEventList,
        callback: ((res) => {
          this.commit('SORTEDMATCHEVENTLIST', _.cloneDeep(res))
        })
      })
    },
    [types.VIRTUAL_DATA_LIST] (state, payload) {
      state.virtualDataList = payload
    },
    [types.SHOW_LEG_CAP] (state, payload) {
      state.showLegCapt = payload
    },
    [types.LEG_CAPT_DATA_LIST] (state, payload) {
      state.legCaptDataList = payload
    },
    [types.OTRHIDELGE_LIST] (state, payload) {
      if(!_.isUndefined(payload.lid) && !_.isUndefined(payload.key)) {
        if(_.isUndefined(state.otrHideLegList[payload.lid])){
          state.otrHideLegList[payload.lid]=[];
        }
        if(_.indexOf(state.otrHideLegList[payload.lid], payload.key ) < 0 ) {
          state.otrHideLegList[payload.lid].push(payload.key)
        }else{
          // state.otrHideLegList[payload.lid].splice( _.indexOf(state.otrHideLegList[payload.lid], payload.key), 1 );
        }
      }
    },
    [types.OTRHIDETITLE_LIST](state, payload) {
      state.otrHideTitleList = payload
    },
    [types.FAVOURITELGEVENT](state, payload) {
      if (payload.clear) {
        payload.clear ? {} : state.favouriteLgeEvents
        state.showFavEvents = false
      } else {
        let VUE = this
        function recursiveMethod(value, type, league) {
          var selectedMarket = VUE.getters.selectedMarket
          var selectedSport = VUE.getters.arr_selectedTemplate.sportId
          if (value == null && type == 'market') {
            value = {}
            return recursiveMethod(value, 'sport', league)
          }
          if (value == null) {
            return recursiveMethod(value, 'market', league)
          }
          if (value[selectedSport] == null) {
            value[selectedSport] = []
            value[selectedSport].push(league)
            return value
          }
          value[selectedSport].push(league)
          return value;
        }

        if (!_.isUndefined(state.favouriteLgeEvents) && _.indexOf(state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId], payload.eventObj.eveid) >= 0) {
          state.favouriteLgeEvents = {}
          this.commit('ACCOUNT_FAV', { favdt: state.favouriteLgeEvents, isFavLeague: '0' })
        } else {

          if (Object.keys(state.favouriteLgeEvents).length <= 0) {
            state.favouriteLgeEvents = {}
            this.commit('ACCOUNT_FAV', { favdt: state.favouriteLgeEvents, isFavLeague: '0' })
          }
        }

        if (!_.isUndefined(state.favouriteLgeEvents) && _.indexOf(state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId], payload.lgeid) >= 0) {
          _.pull(state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId], payload.lgeid)
          this.commit('ACCOUNT_FAV', { favdt: state.favouriteLgeEvents, isFavLeague: '1' })
          if (state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId].length <= 0) {
            delete state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId]
            if (Object.keys(state.favouriteLgeEvents).length <= 0) {
              state.favouriteLgeEvents = {}
            }
            this.commit('ACCOUNT_FAV', { favdt: state.favouriteLgeEvents, isFavLeague: '1' })
          }
        } else {
          if (Object.keys(state.favouriteLgeEvents).length <= 0) {
            state.favouriteLgeEvents = {}
            state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId] = [payload.lgeid]
            this.commit('ACCOUNT_FAV', { favdt: state.favouriteLgeEvents, isFavLeague: '1' })
          } else {
            var fav = recursiveMethod(state.favouriteLgeEvents, 'market', payload.lgeid)
            this.commit('ACCOUNT_FAV', { favdt: fav, isFavLeague: '0' })
          }
        }
        
        _.forEach(state.sortedFavOtrEventList, ((events, eventsKey) => {
            if (state.sortedFavOtrEventList[eventsKey].lgeid == payload.lgeid) {
              if (state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId] && state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId].includes(state.sortedFavOtrEventList[eventsKey].eveid)) {
                _.pull(state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId], state.sortedFavOtrEventList[eventsKey].eveid)
                if (state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId].length <= 0) {
                  delete state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId]
                  if (Object.keys(state.favouriteLgeEvents).length <= 0) {
                    state.favouriteLgeEvents = {}
                    this.commit('ACCOUNT_FAV', { favdt: state.favouriteLgeEvents, isFavLeague: '' })
                  }
                }
              }
              if (payload.lgeChk) {
                state.sortedFavOtrEventList[eventsKey].isFavourite = false
              } else {
                state.sortedFavOtrEventList[eventsKey].isFavourite = true
              }
            }
        }))
        
        var nwArr = []
        _.forEach(state.sortedFavOtrEventList, ((eve, eveKey) => {
          if(_.includes(state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId], eve.lgeid)){
            nwArr.push(eve.eveid)
          }
        }))
        state.favouriteEvents[VUE.getters.arr_selectedTemplate.sportId] = nwArr
        this.commit('SORTEDFAVOTREVENTLIST', _.cloneDeep(state.sortedFavOtrEventList))
      }
    },
    [types.OTRHIDEFAVLGE_LIST](state, payload) {
      if(!_.isUndefined(payload.lid) && !_.isUndefined(payload.key)) {
        if(_.isUndefined(state.otrHideFavLegList[payload.lid])){
          state.otrHideFavLegList[payload.lid]=[];
        }
        if(_.indexOf(state.otrHideFavLegList[payload.lid], payload.key ) < 0 ) {
          state.otrHideFavLegList[payload.lid].push(payload.key)
        }
      }
    },
    [types.OTRHIDEFAVTITLE_LIST](state, payload) {
      state.otrHideFavTitleList = payload
    },
    [types.HOT_MATCH_LIST](state, payload){
      state.hotMatchList = payload
    },
    LEAGUE_FILTER(state, payload){
      state.filter_leagueList = payload
    },
    SCHEDULE(state, payload){
      state.schedule = payload
    },
    PLAYTYPE(state, payload){
      state.playtype = payload
    },
    FAVOURITE_TEAM(state, payload){
      const teamId = payload.team === 'a' ? payload.event.taid : payload.event.tbid;
      const sport = payload.sport;

      const currentList = (!state.favouriteTeams[sport])? []:state.favouriteTeams[sport]
      const index = currentList.indexOf(teamId);
      let newList;

      if (index >= 0) { // remove
        newList = currentList.filter(id => id !== teamId);
      } else { // add
        newList = [...currentList, teamId];
      }

      if (newList.length > 0) {
        state.favouriteTeams = {
          ...state.favouriteTeams,
          [sport]: newList
        };
      } else {
        const { [sport]: _, ...rest } = state.favouriteTeams;
        state.favouriteTeams = rest;
      }

      if (Object.keys(state.favouriteTeams).length === 0) {
        state.favouriteTeams = {};
      }
    },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./resources/score/vue/store/modules/sport-odds.js